import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-check-alt text-app-primary" }),
  /*#__PURE__*/_createTextVNode(" Health Benefit Plan Coverage Payers ")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "border bg-white p-2 mt-2 h-100" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "my-1"
}
const _hoisted_7 = {
  key: 1,
  class: "my-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1 /* HOISTED */)
const _hoisted_9 = {
  key: 2,
  class: "my-1"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-book" }, null, -1 /* HOISTED */)
const _hoisted_11 = {
  key: 3,
  class: "my-1"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1 /* HOISTED */)
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h6", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-check-alt text-app-primary" }),
  /*#__PURE__*/_createTextVNode(" Medicare Advantage Payers")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "border bg-white p-2 mt-2 h-100" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["href"]
const _hoisted_19 = {
  key: 1,
  class: "my-1"
}
const _hoisted_20 = {
  key: 2,
  class: "my-1"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1 /* HOISTED */)
const _hoisted_22 = {
  key: 3,
  class: "my-1"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-address-book" }, null, -1 /* HOISTED */)
const _hoisted_24 = {
  key: 4,
  class: "my-1"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-mobile-alt" }, null, -1 /* HOISTED */)
const _hoisted_26 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.eligibility?.health_Benefit_Plan_Coverage.success == 'Yes')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(`py-3 row ${
                _ctx.eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers.length > 1 ? 'col-12' : 'col-6'
            }`)
        }, [
          _hoisted_2,
          (_ctx.eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers, (coveragePayer) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: coveragePayer.reference_id,
                  class: _normalizeClass(`${
                    _ctx.eligibility.health_Benefit_Plan_Coverage.healthBenefitPlanCoveragePayers.length > 1
                        ? 'col-12 col-md-6 col-lg-4'
                        : 'col-12'
                }`)
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h6", null, [
                      (coveragePayer.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(coveragePayer.payer) + ": " + _toDisplayString(coveragePayer.name), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (coveragePayer.insurance_type)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, ", " + _toDisplayString(coveragePayer.insurance_type), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (coveragePayer.reference_id)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(coveragePayer.reference_id_qualifier) + ": " + _toDisplayString(coveragePayer.reference_id), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (coveragePayer.date)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                          _hoisted_8,
                          _createTextVNode(" " + _toDisplayString(coveragePayer.date), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (coveragePayer.address1 || coveragePayer.city || coveragePayer.state || coveragePayer.zip)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(coveragePayer.address1) + ", " + _toDisplayString(coveragePayer.city) + ", " + _toDisplayString(coveragePayer.state) + ", " + _toDisplayString(coveragePayer.zip), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (coveragePayer.phone)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("a", {
                            href: `tel:${coveragePayer.phone}`
                          }, _toDisplayString(_ctx.formatPhoneNumber(coveragePayer.phone)), 9 /* TEXT, PROPS */, _hoisted_13)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    (_ctx.eligibility?.medicareAdvantage.success == 'Yes')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(`py-3 row ${_ctx.eligibility.medicareAdvantage.medicareAdvantagePayers.length > 1 ? 'col-12' : 'col-6'}`)
        }, [
          _hoisted_14,
          (_ctx.eligibility.medicareAdvantage.medicareAdvantagePayers)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.eligibility.medicareAdvantage.medicareAdvantagePayers, (advantagePayer) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: advantagePayer.reference_id,
                  class: _normalizeClass(`${
                    _ctx.eligibility.medicareAdvantage.medicareAdvantagePayers.length > 1
                        ? 'col-12 col-md-6 col-lg-4'
                        : 'col-12'
                }`)
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h6", null, [
                      (advantagePayer.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(advantagePayer.payer) + ": " + _toDisplayString(advantagePayer.name), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (advantagePayer.insurance_type)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, ", " + _toDisplayString(advantagePayer.insurance_type), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (advantagePayer.url)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: `http://${advantagePayer.url}`,
                          target: "_blank",
                          class: "my-1"
                        }, _toDisplayString(advantagePayer.url), 9 /* TEXT, PROPS */, _hoisted_18))
                      : _createCommentVNode("v-if", true),
                    (advantagePayer.reference_id)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(advantagePayer.reference_id_qualifier) + ": " + _toDisplayString(advantagePayer.reference_id), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (advantagePayer.date)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                          _hoisted_21,
                          _createTextVNode(" " + _toDisplayString(advantagePayer.date), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (
                            advantagePayer.address1 || advantagePayer.city || advantagePayer.state || advantagePayer.zip
                        )
                      ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                          _hoisted_23,
                          _createTextVNode(" " + _toDisplayString(advantagePayer.address1) + ", " + _toDisplayString(advantagePayer.city) + ", " + _toDisplayString(advantagePayer.state) + ", " + _toDisplayString(advantagePayer.zip), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (advantagePayer.phone)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("a", {
                            href: `tel:${advantagePayer.phone}`
                          }, _toDisplayString(_ctx.formatPhoneNumber(advantagePayer.phone)), 9 /* TEXT, PROPS */, _hoisted_26)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true)
  ]))
}